export default __webpack_public_path__ + "static/media/speech.e233cdb9.jpg";